/* eslint-disable react/jsx-no-literals */
import React, {Component} from 'react';
import './BrandConsolidationBanner.less';
import LINGUA_DEFAULT_DATA from './data.js';

class BrandConsolidationBanner extends Component {
    static defaultProps = {
        onHidden: () => {}
    };

    constructor() {
        super();
        this.state = {hidden: (typeof window !== 'undefined' && window.localStorage) ? window.localStorage.getItem('hideBrandConsolidationBanner') : false};
        this.handleCloseBanner = this.handleCloseBanner.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.hidden && (prevState.hidden !== this.state.hidden)) {
            this.props.onHidden();
        }
    }

    handleCloseBanner() {
        this.setState({hidden: true});
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem('hideBrandConsolidationBanner', true);
        }
    }

    render() {
        let isHidden = this.state.hidden;
        let lingua = this.props.lingua;
        let site = this.props.siteName;
        if (!lingua) {
            lingua = LINGUA_DEFAULT_DATA[site];
        }

        if (isHidden || !lingua) {
            return null;
        }

        return (
            <div className="brand-consolidation-banner">
                <button type="button" className="close" onClick={this.handleCloseBanner}>
                <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 15L15 1m0 14L1 1" fill="none" stroke-linecap="round" stroke="#fff" stroke-width="1.5px" stroke-linejoin="round"/>
                    </svg>
                </button>
                <span>{lingua.consolidationBannerDesc}</span>
                <span>{lingua.moreInfoPreAnchorText} <a href={lingua.moreInfoHref} target="_blank">{lingua.moreInfoAnchorText}</a>{lingua.moreInfoPostAnchorText}</span>
                <span>{lingua.moreInfo2PreAnchorText} <a href={lingua.moreInfo2Href} target="_blank">{lingua.moreInfo2AnchorText}</a>{lingua.moreInfo2PostAnchorText}</span>
            </div>
        );
    }
}

export default BrandConsolidationBanner;
